export default __webpack_public_path__ + "static/media/feather.98c8510c.mp3";